import { useSteppedContent } from '@mews-commander/ui';
import { StepProps, WithSteps } from '../types';
import { SteppedPrimaryActions, SteppedPrimaryActionsProps } from './SteppedPrimaryActions';

export const useSteppedFormComponents = <S extends string>({ steps }: WithSteps<S>) => {
    const { StepProgressIndicator, state } = useSteppedContent({ steps });
    return {
        StepProgressIndicator,
        SteppedPrimaryActions: (props: Omit<SteppedPrimaryActionsProps<S>, keyof StepProps<S>>) => (
            <SteppedPrimaryActions {...props} {...state} steps={steps} />
        ),
        state,
    };
};
